import "core-js/modules/es.object.assign.js";

/*
 * @Author       : 程哲林
 * @Date         : 2022-05-25 17:29:19
 * @LastEditors  : 程哲林
 * @LastEditTime : 2022-07-19 18:02:43
 * @FilePath     : /marketing-landing-fe/src/helpers/dotRender.ts
 * @Description  : 未添加文件描述
 */
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import dot from 'dot';
import { _trans } from '@/lib/i18next';

function dotRender(tmpl, data, def) {
  if (def === void 0) {
    def = {};
  }

  return dot.template(tmpl, undefined, def)(__assign(__assign({}, data), {
    t: _trans // 传递方法

  }));
}

export default dotRender;